import React from 'react';
import { useNavigate } from 'react-router-dom';
import { XCircle, AlertTriangle, ArrowLeft, RefreshCcw } from 'lucide-react';
import { motion } from 'framer-motion';

const Failure = () => {
  const navigate = useNavigate();

  return (
    <div className="failure-page">
      <div className="container">
        <motion.div 
          initial={{ opacity: 0, y: 20 }}
          animate={{ opacity: 1, y: 0 }}
          className="failure-card"
        >
          <div className="failure-icon-wrapper">
            <XCircle size={80} className="failure-icon" />
          </div>

          <h1 className="failure-title">Payment Failed</h1>
          <p className="failure-subtitle">
            Something went wrong while processing your payment. Don't worry, no money was deducted from your account.
          </p>

          <div className="error-box">
            <AlertTriangle size={18} />
            <span>Error: Transaction declined by bank</span>
          </div>

          <div className="actions">
            <button onClick={() => navigate('/register')} className="retry-btn">
              <RefreshCcw size={20} /> Try Again
            </button>
            <button onClick={() => navigate('/')} className="back-btn">
              <ArrowLeft size={18} /> Back to Event
            </button>
          </div>
        </motion.div>
      </div>
    </div>
  );
};

export default Failure;
